<template>
  <v-sheet tile class="pt-9 mt-1">
    <v-main>
      <v-container>
        <v-card rounded="lg" flat>
          <template v-if="loadingBanners">
            <v-col cols="12">
              <v-skeleton-loader
                type="image"
                height="400px"
                elevation="5"
              ></v-skeleton-loader>
            </v-col>
          </template>
          <template v-else>
            <v-carousel
              cycle
              height="450"
              hide-delimiter-background
              :show-arrows="false"
              :dark="false"
            >
              <v-carousel-item
                v-for="(banner, index) in banners"
                :key="index"
                :dark="false"
              >
                <v-card tile flat :dark="false">
                  <v-img
                    :src="banner.backgroundImage.url"
                    class="white--text align-stretch justify-start"
                    gradient="to left, rgba(0,0,0,.25), rgba(0,0,0,.6)"
                    height="450px"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="5"
                        class="pa-6 pl-8 d-flex align-content-space-between flex-wrap banner-text-area"
                      >
                        <div style="width:100%">
                          <h2 class="header mb-2 white-txt font-weight-black">
                            <b>{{ banner.title }}</b>
                          </h2>
                          <p class="caption white-txt mb-0">
                            {{ banner.content }}
                          </p>
                        </div>
                        <div style="width:100%" class="d-flex justify-md-start align-center justify-center">
                          <v-card
                            color="rgba(255,255,255,0.80)"
                            rounded="lg"
                            v-if="banner.apps.length > 0"
                            :dark="false"
                            @click="goToApp(banner.apps[0].id)"
                          >
                            <v-card-text
                              class="d-flex flex-row flex-nowrap justify-start align-center pa-2"
                            >
                              <v-avatar size="30" style="border-radius:3px">
                                <v-img :src="banner.apps[0].icon.url"></v-img>
                              </v-avatar>
                              <div
                                class="ml-3 d-flex flex-column justify-start align-start"
                              >
                                <h4
                                  class="black-txt ma-0 font-weight-bold"
                                >
                                  {{ banner.apps[0].name }}
                                </h4>
                              </div>
                            </v-card-text>
                          </v-card>
                          <v-card
                            color="rgba(255,255,255,0.80)"
                            rounded="lg"
                            v-else-if="banner.actionType === 'external'"
                            :dark="false"
                            @click="openDetails(banner)"
                          >
                            <v-card-text
                              class="d-flex flex-row flex-nowrap justify-start align-center pa-2"
                            >
                              <div
                                class="ml-3 d-flex flex-column justify-start align-start"
                              >
                                <h4
                                  class="black-txt ma-0 font-weight-bold"
                                >
                                  More information <v-icon size="10">fas fa-external-alt</v-icon>
                                </h4>
                              </div>
                            </v-card-text>
                          </v-card>
                        </div>
                      </v-col>
                    </v-row>
                  </v-img>
                </v-card>
              </v-carousel-item>
            </v-carousel>
          </template>
        </v-card>
        <v-row>
          <v-col cols="12" sm="4">
            <div class="pa-4">
              <h3 class="heading text-primary mb-1">
                <b>Join us</b>
              </h3>
              <p class="body-small text-primary">
                We are working hard to enable developers to submit their own
                avWiFi apps to the Catalog. Enter your email address for more information.
              </p>
              <v-row>
                <v-col cols="12" md="12">
                  <NtInputText
                    type="primary"
                    label="Email address"
                    v-model="email"
                    :disabled="loadingPeople || submittingPerson"
                  />
                  <v-btn
                    depressed
                    color="primary"
                    class="mt-5"
                    @click="checkPeople"
                    :disabled="
                      email === '' ||
                        !emailRule ||
                        loadingPeople ||
                        submittingPerson
                    "
                    >Let me know</v-btn
                  >
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" sm="8">
            <template v-if="loadingApps">
              <v-row>
                <v-col
                  v-for="n in 6"
                  :key="n"
                  :cols="12"
                  lg="4"
                  md="6"
                  sm="3"
                  x-sm="12"
                >
                  <v-skeleton-loader
                    type="card"
                    elevation="1"
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
            </template>
            <v-container fluid v-if="apps">
              <v-row>
                <v-col
                  v-for="app in apps"
                  :key="app.title"
                  :cols="12"
                  lg="4"
                  md="6"
                  sm="6"
                  x-sm="12"
                >
                  <v-card hover @click="showAppDetails(app.id)">
                    <v-img
                      v-if="app.adMedia"
                      :src="app.adMedia.url"
                      class="white--text align-end"
                      height="200px"
                      aspect-ratio="1"
                    >
                    </v-img>
                    <v-img
                      v-else
                      :src="app.icon.url"
                      class="white--text align-end"
                      height="200px"
                      aspect-ratio="1"
                    >
                    </v-img>
                    <v-card-text
                      class="d-flex flex-row flex-nowrap justify-start align-center"
                    >
                      <v-avatar size="45" style="border-radius:3px">
                        <v-img :src="app.icon.url"></v-img>
                      </v-avatar>
                      <div class="ml-3">
                        <h4 class="text-primary">{{ app.name }}</h4>
                        <div
                          class="d-flex flex-row justify-start align-baseline text-truncate"
                        >
                          <p
                            class="d-block body-small text-secondary text-truncate mr-2 mb-0"
                          >
                            {{ app.publisher.name }}
                          </p>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            <template v-else-if="!loadingApps && errorLoadingApps">
              <div class="d-flex align-center justify-center">
                <p>There's an unexpected error loading our apps.</p>
              </div>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <NtDialog
      :showDialog="infoDialog.show"
      :title="infoDialog.title"
      @close="infoDialog.show = false"
    >
      <template v-slot:dialogContent>
        {{ infoDialog.content }}
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores qui
          nulla distinctio? Tenetur sed architecto, error incidunt sequi vero
          qui perspiciatis at laudantium consectetur placeat fugit sint laborum,
          itaque iure.
        </p>
      </template>
    </NtDialog>
    <NtAlert
      :type="alert.type"
      :title="alert.title"
      :details="alert.details"
      :value="alert.show"
      @close="alert.show = false"
    />
    <FullLoader
      v-if="loadingApps || loadingBanners"
      loadingMessage="We're loading your content"
      class="app-loader"
    />
  </v-sheet>
</template>

<script>
import { mapState, mapActions } from "vuex";
import FullLoader from "./shared/FullLoader.vue";

export default {
  name: "AppsListing",
  components: {
    FullLoader,
  },
  data() {
    return {
      infoDialog: {
        title: "",
        content: "",
        show: false,
      },
      alert: {
        title: "",
        details: "",
        type: "",
        show: false,
      },
      email: "",
      emailRule: false,
      onboarding: 0,
    };
  },

  methods: {
    ...mapActions("interestedPerson", ["getPeople", "addPerson"]),
    activateAlert(type, title, details) {
      this.alert.title = title;
      this.alert.details = details;
      this.alert.type = type;
      this.alert.show = true;
    },
    openDetails(banner) {
      if (banner.actionType === "showDialog") {
        this.infoDialog.title = banner.title;
        this.infoDialog.content = banner.content;
        this.infoDialog.show = true;
      } else if (banner.actionType === "external") {
        window.open(banner.to, "_blank");
      } else if (banner.actionType === "app") {
        this.$router.push({ name: "appDetails", params: { id: banner.to } });
      }
    },
    showAppDetails(appID) {
      this.$router.push({ name: "appDetails", params: { id: appID } });
    },
    checkPeople() {
      Promise.all([this.getPeople()]).then(() => this.lookForDuplicates());
    },
    lookForDuplicates() {
      let result = this.people.filter((people) => people.email === this.email);

      if (result.length === 0) {
        this.addPerson({ email: this.email });
      }
      this.email = "";
      this.activateAlert(
        "success",
        "All set!",
        "We will get in touch with you as soon as we get it all set up for you to upload your own apps."
      );
    },
    goToApp(appID) {
      this.$router.push({ name: "appDetails", params: { id: appID } });
    },
  },

  computed: {
    ...mapState({
      apps: (state) => state.apps.data,
      loadingApps: (state) => state.apps.loadingData,
      errorLoadingApps: (state) => state.apps.errorLoadingData,
      banners: (state) => state.banners.data,
      loadingBanners: (state) => state.banners.loadingData,
      errorLoadingBanners: (state) => state.banners.errorLoadingData,
      people: (state) => state.interestedPerson.data,
      loadingPeople: (state) => state.interestedPerson.loadingPeople,
      errorLoadingPeople: (state) => state.interestedPerson.errorLoadingPeople,
      submittingPerson: (state) => state.interestedPerson.submittingPerson,
      errorSubmittingPerson: (state) =>
        state.interestedPerson.errorSubmittingPerson,
    }),
  },

  created() {
    if (window.localStorage.getItem("redirectToRequest")) {
      window.location.assign(localStorage.getItem("redirectToRequest"));
    } else {
      this.$store.dispatch("apps/getApps");
      this.$store.dispatch("banners/getBanners");
    }
  },

  watch: {
    "alert.show": function() {
      if (this.alert.show) {
        setTimeout(() => {
          this.alert.show = false;
        }, 4000);
      }
    },
    email: function() {
      if (this.email.includes("@")) {
        this.emailRule = true;
      } else {
        this.emailRule = false;
      }
    },
  },
};
</script>
<style>
.overflow-x {
  overflow-x: auto;
}
.white-txt {
  color: white;
}
.black-txt {
  color: black !important;
}
.banner-text-area {
  /* backdrop-filter: blur(10px); */
  min-height: 415px;
  height: 100%;
}
</style>
